var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('ue-header'),(_vm.bannerList)?_c('router-view',{staticClass:"container ue-body"}):_vm._e(),_c('ue-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }